var app = angular.module('leonardo');

var WPEnterDirective = function () {
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if (event.keyCode === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.wpEnter);
        });
        event.preventDefault();
      }
    });
  };
};

app.directive('wpEnter', [WPEnterDirective]);
